export function BrandMark() {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden="true"
      className="h-6 w-6 shrink-0"
    >
      <path
        d="M24 6H13a10 10 0 0 0 0 20h11M24 12H13a4 4 0 0 0 0 8h11"
        stroke="currentColor"
        strokeWidth="3.2"
        strokeLinecap="round"
      />
      <circle cx="24" cy="6" r="2.2" fill="currentColor" />
      <circle cx="24" cy="20" r="2.2" fill="currentColor" />
    </svg>
  );
}
